import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#003A7C',
          danger: '#FF0000',
          warning: '#FF7F00',
          background: 'transparent'
        },
      },
    }
});
